import { render, staticRenderFns } from "./minha-area.vue?vue&type=template&id=434cbb6a&"
import script from "./minha-area.vue?vue&type=script&lang=js&"
export * from "./minha-area.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports